import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en-US.json';
import zh from './locales/zh-CN.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: en,
      },
      'zh-CN': {
        translation: zh,
      },
    },
    fallbackLng: 'en-US',
    lng: 'en-US', // 设置默认语言为英文
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'querystring', 'cookie'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    // 当找不到翻译键时，返回键本身
    returnEmptyString: false,
    returnNull: false,
    returnObjects: false,
    // 显示缺失的键
    saveMissing: false,
    missingKeyHandler: false,
  });

// 监听语言变化，同步到 store
// i18n.on('languageChanged', lng => {
//   // 动态导入 store 避免循环依赖
//   import('@/stores/appStore').then(({ useStore }) => {
//     const store = useStore.getState();
//     if (store.app.language !== lng) {
//       store.app.setLanguage(lng);
//     }
//   });
// });

export default i18n;
